<script lang="ts">

    import { onMount } from "svelte";
    import { Level, ToastProperties } from "../scripts/toaster";

    export let props: ToastProperties = {message: "", level: ""};
    let show_toaster: boolean = false;
	
    onMount(async () => {
        launch_toast();
    });

    function launch_toast() {
        show_toaster = true;
        if (props.level == Level.ERROR) {
            setTimeout(function(){ show_toaster = false; }, 6200);
        } else {
            setTimeout(function(){ show_toaster = false; }, 6200);
        }
    }

</script>

<style lang="scss">

    .toast {
        display: none;
        max-width: 0px;
        height: 50px;
        margin: auto;
        background-color: #333;
        color: #fff;
        text-align: center;
        border-radius: 2px;
        z-index: 1;
        font-size: 17px;
        white-space: nowrap;
        border-radius: 10px;
        font-size: 12px;
        &__info {
            background-color: $color_primary;
            color: $color_white;
        }
        &__warning {
            background-color: orange;
        }
        &__error {
            background-color: red;
        }
        &__displayed {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            animation: up 0.2s, fadein 1s 0.2s, expand 1s 0.2s, stay 4s 1.2s, fadeout 1s 5.2s;
            overflow: hidden;
            margin: 4px 4px 4px 4px;
        }
    }

    @keyframes fadein {
        from {opacity: 0;}
        to {opacity: 1;}
    }

    @keyframes up {
        from {height: 0px}
        to {height: 50px}
    }
    
    @keyframes expand {
        from {min-width: 0px}
        to {min-width: 350px}
    }

    @keyframes stay {
        from {min-width: 350px}
        to {min-width: 350px}
    }

    @keyframes fadeout {
        from {min-width: 350px; opacity: 1;}
        to {min-width: 350px; opacity: 0;}
    }

    @include large {

        .toast {
            font-size: 18px;
        }

        @keyframes expand {
            from {min-width: 0px}
            to {min-width: 550px}
        }

        @keyframes stay {
            from {min-width: 550px}
            to {min-width: 550px}
        }

        @keyframes fadeout {
            from {min-width: 550px; opacity: 1;}
            to {min-width: 550px; opacity: 0;}
        }
    }

</style>

<div class="toast"
    class:toast__displayed={show_toaster}
    class:toast__displayed__error={props.level == Level.ERROR}
    class:toast__info={props.level == Level.INFO}
    class:toast__warning={props.level == Level.WARNING}
    class:toast__error={props.level == Level.ERROR}>
    <div>{@html props.message}</div>
</div>
